var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 7.49998V4.99998C12.4997 2.69879 10.6342 0.833313 8.33301 0.833313C6.03182 0.833313 4.16634 2.69879 4.16634 4.99998V7.49998M4.83301 15.8333H11.833C13.2331 15.8333 13.9332 15.8333 14.468 15.5608C14.9384 15.3211 15.3208 14.9387 15.5605 14.4683C15.833 13.9335 15.833 13.2334 15.833 11.8333V11.5C15.833 10.0998 15.833 9.39978 15.5605 8.865C15.3208 8.3946 14.9384 8.01215 14.468 7.77246C13.9332 7.49998 13.2331 7.49998 11.833 7.49998H4.83301C3.43288 7.49998 2.73281 7.49998 2.19803 7.77246C1.72763 8.01215 1.34517 8.3946 1.10549 8.865C0.833008 9.39978 0.833008 10.0998 0.833008 11.5V11.8333C0.833008 13.2334 0.833008 13.9335 1.10549 14.4683C1.34517 14.9387 1.72763 15.3211 2.19803 15.5608C2.73281 15.8333 3.43288 15.8333 4.83301 15.8333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLock);
export default __webpack_public_path__ + "static/media/white-lock.ec9759a5b007cb25a37b5f40b6c53c04.svg";
export { ForwardRef as ReactComponent };